import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ClientsService } from 'src/app/services/clients.service';
import { LanguageService } from 'src/app/services/language.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-initial-call',
  templateUrl: './initial-call.component.html',
  styleUrl: './initial-call.component.scss'
})
export class InitialCallComponent {
  @ViewChild('loadingModalTemplate', { static: true })
  loadingModalTemplate!: TemplateRef<any>;
  public companyName: string = environment.company;
  public processing: boolean=true;
  public clientInfo: any = {};
  protected clientId:number;
  public userRoles: any|null = null;
  public referralLink: string;
  public language:string = this.languageService.getLanguage();
  constructor(private clientService: ClientsService,
    private authService: AuthService,
    private activeRoute: ActivatedRoute,
    private languageService: LanguageService
  ) { }

  ngOnInit(): void {
    this.getUserRoles();
  }

  getUserRoles() {
    this.authService.getRoles().subscribe({
      next: response => { 
        this.userRoles = response.data;
        // console.log(this.userRoles)
        if (this.userRoles.is_user) {
          this.getCurrentUserData();
       } else {
        this.activeRoute.params.subscribe(params => {
          this.clientId = params.id;
        })
        this.consultClientData(this.clientId)
      }
      },
      error: error => {
        console.log("Error: ",error)
      }
    });
  }

  consultClientData(uid: number) {
    this.clientService.getUserById(uid).subscribe({
      next: response => {
        // console.log(response.data)
        this.clientInfo = response.data;
      },
      complete: () => {
        this.processing = false;
      },
      error: error => {
        console.error(error)
      }
    });
  }

  getReferralLink() {
    this.referralLink = `https://${environment.links.landing_base_link}${this.language}/r/${this.clientInfo?.username}`;
  }

  getCurrentUserData() {
    this.clientService.getCurrentUser().subscribe({
      next: response => {
        // console.log(response);
        this.clientInfo = response.account;
        this.getReferralLink();
        localStorage.setItem('user', JSON.stringify(this.clientInfo))
        this.clientId = this.clientInfo.id;
      },
      complete: () => {this.processing = false; },
      error: error => {
        console.log("Consult User Error",error)
      }
    });
  }
}
